import React from 'react';

class Title extends React.Component {
    render(){
        return(
            <section className="survey">
                <div className="survey__block">
                    <h1 className="survey__title"><b>SURVEY</b>STUDIO</h1>
                    <img className="survey__img" src="images/surveystudio.png" alt="" role="presentation"/>
                    <p className="survey__subtitle">Универсальный сервис сбора, хранения и обработки маркетинговых,
                    статистических и социологических данных.</p>
                    <p className="survey__subtitle">Основное назначение -
                    предоставление инструментов разработки и проведения опросов и интервью.</p>
                    <p className="survey__begin">Использование <b>SURVEY</b>STUDIO не требует покупки или аренды, установки и
                    обслуживания программного и аппаратного обеспечения, а также не имеет практически никаких
                    ограничений на количество и оснащение рабочих мест - достаточно открыть браузер на любом
                    подключенном к сети Интернет устройстве.</p>
                </div>
            </section>
        )
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/Components/SurveyStudio/Title.js